import { useEffect, useState } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { ApplicationProps } from '../../redux-store/types/api-types';
import { Gridstyles } from '../Investments/investor-application';
import { KeyValue } from './contributor';
import { SubHeading } from '../investors/components';
import { checkApplicableForYes } from '../../utils/utilityFunctions';
import { citiesType, mdmsCitiesList } from '../../redux-store/types/mdms';
import { getCitiesList } from '../../redux-store/actions';

import { useDispatch } from 'react-redux';

export default function DistributorDetails({
  application,
}: {
  application: ApplicationProps;
}): JSX.Element {
  const dispatch = useDispatch();
  const [citiesList, setCitiesList] = useState<mdmsCitiesList[]>([]);
  const userIsRia = checkApplicableForYes(application?.distributor?.isRia || '');

  useEffect(() => {
    const callcitiesList = async () => {
      const citiesMdmsMasters = (await dispatch(getCitiesList())) as unknown as citiesType;
      setCitiesList(citiesMdmsMasters?.cities || []);
    };
    callcitiesList();
  }, []);

  return (
    <>
      <Box
        sx={{
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
          borderRadius: '10px',
        }}>
        <Box sx={{ p: 2 }}>
          <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
              <Typography sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main' }}>
                Maker Details
              </Typography>
            </Grid>

            {application.rm_id && (
              <Box sx={{ width: '100%' }}>
                <SubHeading
                  sx={{
                    color: 'common.black',
                    letterSpacing: 0.5 + 'px',
                    padding: { xs: '10px 10px', sm: '10px 30px' },
                  }}>
                  UNIFI RM Details
                </SubHeading>
                <Gridstyles>
                  <Grid
                    item
                    container
                    pt={1}
                    pb={5}
                    rowSpacing={6}
                    columnSpacing={13}
                    direction="row"
                    justifyContent="space-between"
                    alignItems="flex-start">
                    <KeyValue title={`RM's Name`} description={application?.rm?.name} />
                    <KeyValue
                      title={"RM's Email Address"}
                      description={application?.rm?.user?.email}
                    />
                    <KeyValue
                      title={"RM's Mobile Number"}
                      description={application?.rm?.user?.phone}
                    />
                    <KeyValue title={`RM's Custodian Name`} description={application?.custodian} />
                  </Grid>
                </Gridstyles>
              </Box>
            )}

            {application?.distributor && (
              <Box sx={{ width: '100%' }}>
                <SubHeading
                  sx={{
                    color: 'common.black',
                    letterSpacing: 0.5 + 'px',
                    padding: { xs: '10px 10px', sm: '10px 30px' },
                  }}>
                  {` ${userIsRia ? 'RIA' : 'Distributor'}
              Details`}
                </SubHeading>
                <Gridstyles>
                  <Grid
                    item
                    container
                    pt={1}
                    pb={5}
                    rowSpacing={6}
                    columnSpacing={13}
                    direction="row"
                    justifyContent="space-between"
                    alignItems="flex-start">
                    <KeyValue
                      title={`${userIsRia ? 'RIA' : 'Distributor'} Code`}
                      description={application?.distributor?.arnCode}
                    />
                    <KeyValue
                      title={`${userIsRia ? 'RIA' : 'Distributor'}/IFA Name`}
                      description={application?.distributor?.name}
                    />
                    {!userIsRia && (
                      <>
                        <KeyValue
                          title={'Distributor/IFA APRN Number'}
                          description={application?.distributor?.aprn}
                        />
                        <KeyValue
                          title={'Distributor/IFA EUIN Number'}
                          description={application?.distributor?.euin}
                        />
                      </>
                    )}

                    <KeyValue
                      title={`${userIsRia ? "RIA's" : "Distributor's"} RM Code`}
                      description={application?.subDistributor?.distributors_RM_Code}
                    />
                    <KeyValue
                      title={`${userIsRia ? "RIA's" : "Distributor's"} RM Name`}
                      description={application?.subDistributor?.user?.firstName}
                    />

                    <KeyValue
                      title={`${userIsRia ? 'RIA' : 'Distributor'} RM/IFA Email`}
                      description={
                        application?.subDistributor?.user?.email ||
                        application?.distributor?.user?.email
                      }
                    />
                    <KeyValue
                      title={`${userIsRia ? 'RIA' : 'Distributor'} RM/IFA Mobile Number`}
                      description={
                        application?.subDistributor?.user?.phone ||
                        application?.distributor?.user?.phone
                      }
                    />
                    {application?.distributor.type === 'company' &&
                      !checkApplicableForYes(application?.subDistributor?.isRia || '') && (
                        <>
                          <KeyValue
                            title={"Distributor's RM APRN Number"}
                            description={application?.subDistributor?.aprn}
                          />
                          <KeyValue
                            title={"Distributor's RM EUIN Number"}
                            description={application?.subDistributor?.euin}
                          />
                        </>
                      )}
                    <KeyValue
                      title={`${userIsRia ? 'RIA' : 'Distributor'} RM/Advisor Name-Location`}
                      description={
                        application?.subDistributor?.user?.firstName &&
                        `${application?.subDistributor?.user?.firstName}  -
                        ${
                          citiesList.find(
                            (val) => val.code === application?.subDistributor?.location
                          )?.name || 'NA'
                        }`
                      }
                    />

                    <KeyValue title={'Filled By'} description={application?.filledBy} />
                    <KeyValue
                      title={`${userIsRia ? 'RIA' : 'Distributor'} Custodian Name`}
                      description={application?.custodian}
                    />
                  </Grid>
                </Gridstyles>
              </Box>
            )}
          </Grid>
        </Box>
      </Box>
    </>
  );
}
